import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { safeGetItem } from '@/lib/safeBrowser';
import en from './locales/en.json';
import ptBR from './locales/pt-BR.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      'pt-BR': { translation: ptBR },
    },
    lng: safeGetItem('app-language', 'pt-BR') || 'pt-BR',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

// Dev helper: collect missing i18n keys to speed up coverage fixes.
// This does not change runtime behavior (i18next will still return the key),
// but it makes it easy to see what is missing.
if (typeof window !== 'undefined') {
  const STORAGE_KEY = 'i18n-missing-keys';

  const recordMissingKey = (key: string) => {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      const existing = new Set<string>(raw ? (JSON.parse(raw) as string[]) : []);
      if (!existing.has(key)) {
        existing.add(key);
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(existing).sort()));
      }
    } catch {
      // ignore storage errors
    }
  };

  i18n.on('missingKey', (_lngs, _ns, key) => {
    recordMissingKey(key);
    // eslint-disable-next-line no-console
    console.warn(`[i18n] Missing key: ${key}`);
  });
}

export default i18n;
